module.exports = __webpack_public_path__ + "img/wi6teIndex.c4cdbb70.png";